import type { IconData } from '@stacksjs/iconify-core'

export const toiletManFlat: IconData = {
  "body": "<path fill=\"#8fbffa\" d=\"M17.5 8.5a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0-13 0m6.5 8c-3.98 0-7.219.123-9.475.248c-2.182.12-3.65 2.233-2.957 4.317c1.51 4.548 3.336 8.683 4.57 11.294l1.207 11.676c.116 1.117.968 2.034 2.105 2.17c.512.06 1.124.125 1.794.178a1.48 1.48 0 0 0 1.591-1.422l.374-8.982a.5.5 0 0 1 .5-.479h.582a.5.5 0 0 1 .5.48l.373 8.981a1.48 1.48 0 0 0 1.591 1.422c.67-.053 1.283-.118 1.794-.179c1.138-.135 1.99-1.052 2.105-2.169l1.208-11.676c1.234-2.61 3.058-6.746 4.57-11.294c.692-2.084-.776-4.197-2.958-4.317A174 174 0 0 0 24 16.5\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default toiletManFlat
